import { Injectable, isDevMode } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { ReportType } from '@app/domain/model/report-type';
import { catchError } from 'rxjs/operators';
import { PaperCreditModel } from './paper-credit.model';
import { HttpClient } from '@angular/common/http';
import { DateFormatter } from '@app/util/date-formatter';

@Injectable({
  providedIn: 'root'
})
export class PaperCreditService {

  constructor(private http: HttpClient) { }

  addPaperCredit(report: PaperCreditModel): Observable<any> {

    // Convert the purchase report into JSON representation, ...
    const requestBody = JSON.stringify(
      Object.assign({}, {
        dealerId: report.dealerId,
        reportType: ReportType[report.reportType],
        reportDate: DateFormatter.formatDateBeforeSend(report.reportDate),
        receivedDate: DateFormatter.formatDateBeforeSend(report.receivedDate)
      }));

    // ... and send it to the back-end.
    return this.http
      .post('credit/reports/add', requestBody, {headers: {'Content-Type': 'application/json'}})
      .pipe(catchError(this.handleError));
  }

  private handleError(error: Error) {
    if (isDevMode()) {
      console.error('Add paper credit problem: ', error);
    }

    return throwError(error);
  }
}
